<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="isShow"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :z-index="9001"
    @close="isShow = false"
  >
    <el-form
      :model="JZForm"
      ref="JZForm"
      label-width="auto"
      class="content_block"
      label-position="right"
      style="padding-top: 8;padding-bottom:40px;"
    >
      <el-row>
        <el-col :span="24" >
          <el-form-item label="选择" prop="required">
            <el-checkbox v-model="JZForm.specFlag" :true-label="1" :false-label="0">是否规格项</el-checkbox>
            <el-checkbox v-model="JZForm.isIndex" :true-label="1" :false-label="0">索引</el-checkbox>
            <el-checkbox v-model="JZForm.required" :true-label="1" :false-label="0">必填</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <el-form-item label="排序" prop="sort">
            <el-input-number placeholder="请输入排序" v-model.trim="JZForm.sort" :min="0" controls-position="right"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="isShow=false">取 消</el-button>
      <el-button @click="handleSubmit" type="primary">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { updateAttributeItem } from '@/api/PlatformSales/Category.js';
export default {
  name: '',
  methods: {
    initPage () {
      this.isShow = true;
      this.$nextTick(() => {
        this.$refs.JZForm.clearValidate();
      });
    },
    handleSubmit () {
      this.$refs.JZForm.validate((valid) => {
        if (valid) {
          const currentParams = this.JZForm;
          updateAttributeItem(currentParams).then(() => {
            this.isShow = false;
            this.$emit('initPage');
          });
        }
      });
    },
  },
  data () {
    return {
      isShow: false,
      currentAttributeGroupId: '',
      currentId: '',
      dialogTitle: '修改属性',
      JZForm: {
        required: '',
        isIndex: '',
        specFlag: '',
        sort: '',
        attributeGroupId: '',
        attributeId: '',
        attributeName: '',
        categoryId: '',
        id: '',
      },
    };
  },
};
</script>
<style scoped lang='scss'>
/deep/ .content_title_wrapper{
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  i{
    margin-left: 0.5rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.8rem;
    color: #909399;
    text-align: left;
    font-style: normal;
  }
}
/deep/ .vxe-icon-fullscreen.vxe-button--icon{
  background: url('~@/assets/table/ic_zhankai.svg') 100% 100%;
  width: 15px;
  height: 15px;
  background-size: 100% 100%;
  background-position: left top;
  background-size:cover;
  display: inline-block;
  &:before{
    display: none;
  }
}
/deep/ .vxe-icon-minimize.vxe-button--icon{
  background: url('~@/assets/table/ic_shouqi.svg') 100% 100%;
  width: 15px;
  height: 15px;
  background-size: 100% 100%;
  background-position: left top;
  background-size:cover;
  display: inline-block;
  &:before{
    display: none;
  }
}
/deep/ .el-dialog__footer{
  position: absolute;
  bottom:0;
  z-index: 9999;
}
/deep/ .el-dialog__header{
  padding-top: 0;
  padding-bottom: 0;
  border-bottom: 0;;
  display: flex;
  border-bottom: 1px solid #E4E7ED;
  align-items: center;
  height: 40px;
  &>div{
    flex:1;
    height: 48px;
    background: #FFFFFF;
    border-radius: 4px;
    display:flex;
    align-items: center;
    &>.el-dialog__header_title{
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #303133;
      text-align: left;
      font-style: normal;
      flex: 1;
    }
    .titleButtonContainer{
      display:flex;
      align-items: center;
      text-align: right;
    }
  }
}
/deep/ .el-dialog__footer{
  width: 100%;
}
/deep/ .el-dialog__body{
  padding-top: 0;
}
</style>
